import GameContainer from './game'

export default GameContainer